/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon16Solid = forwardRef('ArrowDCornerUpLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.366 1.616a1.25 1.25 0 1 1 1.768 1.768L4.768 5.75H12A3.25 3.25 0 0 1 15.25 9v5.75a1.25 1.25 0 1 1-2.5 0V9a.75.75 0 0 0-.75-.75H4.768l2.366 2.366a1.25 1.25 0 0 1-1.768 1.768L1.715 8.732a2.45 2.45 0 0 1 0-3.464l3.651-3.652Z" })));
});
